import * as React from 'react'
import PropTypes from 'prop-types'

import { INBOX_URL as CONTROLPANEL_REQUESTS_URL } from '../../../models/Controlpanel'
import { DASHBOARD_URL as EVENTPLANNER_REQUESTS_URL } from '../../../models/Eventplanner'

import { ModalButton } from '../../../components/ModalWindow'
import HeaderMenuItem from '../../../ui/header-menu-list-item'
import HeaderMenuButton from '../../../ui/header-menu-button'
import GigRequestUnreadCount from '../../gig-request-unread-count'
import { RequestsUnreadCountWrapper, ButtonInnerContent } from './style'

const RequestsMenuItem = React.memo(
  ({
    artistGigRequestCount,
    eventplannerGigRequestCount,
    onShowRequestOptions,
    showingRequestOptions,
    inDropdown,
  }) => {
    if (artistGigRequestCount > 0 && eventplannerGigRequestCount > 0) {
      return (
        <HeaderMenuItem inDropdown={inDropdown}>
          <>
            <ModalButton
              theme="secondary"
              id="header-request-window"
              isOpen={showingRequestOptions}
              onClick={onShowRequestOptions}
              title="Forespørsler"
              aria-label="Forespørsler"
              renderButton={props => (
                <HeaderMenuButton {...props} inDropdown={inDropdown}>
                  <ButtonInnerContent>
                    Forespørsler
                    <RequestsUnreadCountWrapper inDropdown={inDropdown}>
                      <GigRequestUnreadCount />
                    </RequestsUnreadCountWrapper>
                  </ButtonInnerContent>
                </HeaderMenuButton>
              )}
            />
          </>
        </HeaderMenuItem>
      )
    }
    return (
      <HeaderMenuItem inDropdown={inDropdown}>
        <HeaderMenuButton
          inDropdown={inDropdown}
          to={
            eventplannerGigRequestCount > 0 ? EVENTPLANNER_REQUESTS_URL : CONTROLPANEL_REQUESTS_URL
          }
        >
          <ButtonInnerContent>
            Forespørsler
            <RequestsUnreadCountWrapper inDropdown={inDropdown}>
              <GigRequestUnreadCount />
            </RequestsUnreadCountWrapper>
          </ButtonInnerContent>
        </HeaderMenuButton>
      </HeaderMenuItem>
    )
  },
)

RequestsMenuItem.propTypes = {
  artistGigRequestCount: PropTypes.number.isRequired,
  eventplannerGigRequestCount: PropTypes.number.isRequired,
  onShowRequestOptions: PropTypes.func.isRequired,
  showingRequestOptions: PropTypes.bool.isRequired,
  inDropdown: PropTypes.bool,
}
RequestsMenuItem.defaultProps = {
  inDropdown: false,
}

export default RequestsMenuItem
